var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPs = function SvgPs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ps_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-118 0h682.7v512H-118z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ps_svg__a)",
    transform: "translate(110.6)scale(.9375)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M-246 0H778v170.7H-246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-246 170.7H778v170.6H-246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "M-246 341.3H778V512H-246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m-246 512 512-256L-246 0z"
  })))));
};
export default SvgPs;